import React from "react";
import styled from "styled-components";

import { reactKeyFromIDSK } from "@examspark/common";
import { DisplayName } from "@examspark/common-app";
import { VSpace } from "@examspark/common-ui";
import { ParsedTCMPCUnit, VocabularyItem } from "@examspark/types";

import ContentSection from "../../common/ContentSection";
import { Annotations } from "../Annotations";
import { StyledDefinition, StyledTerm } from "../UnitVocabulary";

const StyledTable = styled.table`
  thead {
    th {
      text-align: left;
      border-bottom: solid 1px #ddd;
      padding: 1rem 0;
    }
  }

  td {
    vertical-align: top;
    padding: 0.6rem 0;
  }

  tbody {
    tr:first-child {
      td {
        padding-top: 1rem;
      }
    }
  }
`;

const UnitVocabularyList = (props: {
  annotationLocationKey: string;
  onVocabularyClick: (index: number) => void;
  showDefinitions?: boolean;
  title: string;
  unit: ParsedTCMPCUnit;
  vocabularies: VocabularyItem[] | undefined;
}) => {
  // these MUST be sorted before this component, or the details modal breaks.
  const sortedVocabularies = props.vocabularies ?? [];

  if (sortedVocabularies.length === 0) return null;

  return (
    <ContentSection
      title={props.title}
      actions={
        <Annotations
          resource={props.unit}
          locationKey={props.annotationLocationKey}
        />
      }
    >
      <VSpace size="2rem">
        <VSpace>
          <StyledTable>
            <thead>
              <th>Term</th>
              <th>Definition</th>
            </thead>
            <tbody>
              {sortedVocabularies.map((vocabulary, index) => (
                <tr key={reactKeyFromIDSK(vocabulary)}>
                  <td>
                    <StyledTerm onClick={() => props.onVocabularyClick(index)}>
                      <DisplayName resource={vocabulary.vocabulary} />
                    </StyledTerm>
                  </td>
                  <td>
                    <StyledDefinition
                      content={vocabulary.vocabulary?.description}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </StyledTable>
        </VSpace>
      </VSpace>
    </ContentSection>
  );
};

export default UnitVocabularyList;
